import { withProfiler } from "@sentry/react";
import { ModalStackProvider } from "@modelve/ui";
import AuthProvider from "auth/authProvider";
import { DeleteModelProvider } from "components/deleteModal";
import UserFlow from "components/userflow";
import "mapbox-gl/dist/mapbox-gl.css";
import "notyf/notyf.min.css";
import React, { Suspense } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { SidebarProvider } from "./contexts/SidebarContext";
import "./i18n";
import "./index.css";
import UserProvider from "./providers/userProvider";
import "./utils/arrayUtils";

const Content = React.lazy(() => import("components/AuthContent"));

function App() {
  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | Modelve - Asset Investment Planning"
        defaultTitle="Modelve - Asset Investment Planning"
      />
      <ModalStackProvider>
        <AuthProvider>
          <UserProvider>
            <UserFlow>
              <SidebarProvider>
                <DeleteModelProvider>
                  <Suspense>
                    <Content />
                  </Suspense>
                </DeleteModelProvider>
              </SidebarProvider>
            </UserFlow>
          </UserProvider>
        </AuthProvider>
      </ModalStackProvider>
    </HelmetProvider>
  );
}

export default withProfiler(App);
